import React, { memo, useCallback, useContext, useMemo, useState } from 'react';
import styled from 'styled-components';
import { ReturnToCartPopup } from '@sunbit-dev/purchase-common/src/components/returnToCartPopup/ReturnToCartPopup';
import * as styles from './styles';
import { Top } from '@sunbit-dev/purchase-common/src/components/top/Top';
import { IApplyOnlineLayout } from './models';
import { LegalSectionSkipLP } from '../LegalSectionSkipLP/LegalSectionSkipLP';
import { ABTestsContext } from '~/contexts/abTests/abTestsContext';
import { AbTests } from '~/constants/abTests';
import { SupportPopup } from '@sunbit-dev/purchase-common/src/components/supportPopup/SupportPopup';
import { PrivacyAllowanceLayer } from '@sunbit-dev/purchase-common/src/components/privacyAllowanceLayer/PrivacyAllowanceLayer';
import { useQueryParams } from '~/hooks/useQueryParams';

const CustomerVerifiedPage = React.lazy(() => import('../CustomerVerifiedPage/CustomerVerifiedPage'));

const ApplyOnlineLayout = styled(({ className, page, returnToCartAction, children, currentPageName }: IApplyOnlineLayout) => {
  const { showStepper, step: currentStep } = page || {};

  const [isReturnToCartPopupOpen, setIsReturnToCartPopupOpen] = useState(false);

  const abTestsContext = useContext(ABTestsContext);
  const { isActive: isSkipLPTestActive } = useMemo(() => abTestsContext.data.get({ testName: AbTests.SkipLandingPage }), [abTestsContext.data]);

  const onReturnToCart = useCallback(() => {
    returnToCartAction();
  }, [returnToCartAction]);

  const toggleReturnToCartPopup = useCallback(() => {
    setIsReturnToCartPopupOpen((state) => !state);
  }, []);

  const [isSupportPopupOpen, setIsSupportPopupOpen] = useState(false);

  const toggleSupportPopup = useCallback(() => {
    setIsSupportPopupOpen((state) => !state);
  }, []);

  const showProgressBar = showStepper && currentStep !== undefined;

  const { customerVerified } = useQueryParams();
  const [showCustomerVerifiedPage, setShowCustomerVerifiedPage] = useState(!!customerVerified);
  const dismissCustomerVerifiedPage = useCallback(() => {
    setShowCustomerVerifiedPage(false);
  }, []);

  return (
    <div {...{ className, 'data-at': 'checkout-layout' }}>
      {showCustomerVerifiedPage && <CustomerVerifiedPage {...{ onDismiss: dismissCustomerVerifiedPage }} />}
      <PrivacyAllowanceLayer>
        {isSupportPopupOpen && <SupportPopup {...{ onClose: toggleSupportPopup }} />}
        {isReturnToCartPopupOpen && <ReturnToCartPopup {...{ onConfirm: onReturnToCart, onClose: toggleReturnToCartPopup }} />}
        {isSkipLPTestActive && <LegalSectionSkipLP {...{ currentPageName }} />}

        <Top
          {...{
            className: 'top',
            currentStep,
            showProgressBar,
            headerReturnClick: toggleReturnToCartPopup,
            onSupportClick: toggleSupportPopup,
          }}
        />
      </PrivacyAllowanceLayer>

      <div className="content">{children}</div>
    </div>
  );
})`
  ${styles.ApplyOnlineLayout}
`;

ApplyOnlineLayout.defaultProps = {
  isModal: false,
  showHeaderTitle: false,
};

export default memo<IApplyOnlineLayout>(ApplyOnlineLayout);
